import { ValidationMessageType } from "features/shared/enums/validationMessageType";
import { AlertType } from "features/shared/alerts/enums/alertType";

export const getAlertType = (messageType: ValidationMessageType): AlertType => {
  switch (messageType) {
    case "Warning":
      return "Warning";
    case "Error":
      return "Danger";
    default:
      return "Undefined";
  }
}